import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { UserService } from 'app/Shared/Services/user.service';
import { MessageService } from 'primeng/api';
import { AccordionModule } from 'primeng/accordion';
import { TabsModule } from 'primeng/tabs';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { FileActionsComponent } from './file-actions/file-actions.component';
import { ToastModule } from 'primeng/toast';
import { ComparativeReviewSetupComponent } from '../cognito/comparative-review-setup/comparative-review-setup.component';


@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss'],
    imports: [AccordionModule, TabsModule, ConfirmDialogModule, FileActionsComponent, ToastModule,ComparativeReviewSetupComponent]
})
export class UserComponent implements OnInit {
  fileProcessingType: string = "CAT Exceptions Restore";
  msgs:any;
  constructor(private messageService: MessageService,
    private sharedHttpClientService: SharedHttpClientService,
    private urlsService: UrlsService,
    public constantService: ConstantService,
    public userService: UserService
    ) {}

  onTabChange(event:any) {
    if(event == 1)
    this.fileProcessingType= 'CAT Exceptions Restore';
    else if(event == 2)
    this.fileProcessingType= 'CAT Recon';
    else if(event == 3)
    this.fileProcessingType= 'CAT Analytics';
    else if(event == 4)
    this.fileProcessingType = 'Finra Description';
    else if(event == 5)
    this.fileProcessingType = 'Comparative Review';
    else if (event == 6)
    this.fileProcessingType = 'Comparative Review Setup';
  }

  ngOnInit() {
  }
        

  }
